import React, { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useTranslation } from "@limitless/common/hooks";
import { useKnowledgeLibraryResult } from "./KnowledgeLibraryHook";
import { useDevLogging } from "@limitless/common/hooks/dev-logging/DevLoggingContext";
const KnowledgeLibraryContext = /*#__PURE__*/createContext({});
export const KnowledgeLibraryContextProvider = ({
  children,
  customTranslate
}) => {
  const hook = useKnowledgeLibraryResult(customTranslate);
  const {
    stateTracker
  } = useDevLogging();
  const translationHook = useTranslation();
  const context = useMemo(() => {
    stateTracker.trackState({
      knowledgeLibrary: {
        selectedLibrary: hook.selectedLibrary,
        selectedArticle: hook.selectedArticle,
        libraryResults: hook.libraryResults
      }
    });
    return {
      ...hook
    };
  }, [hook.selectedLibrary, hook.selectedArticle, hook.libraryResults, translationHook.resourceBundle]);
  return /*#__PURE__*/React.createElement(KnowledgeLibraryContext.Provider, {
    value: context
  }, children);
};
export const useKnowledgeLibraryContext = () => {
  return useContext(KnowledgeLibraryContext);
};
KnowledgeLibraryContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  customTranslate: PropTypes.func
};